var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"label":_vm.label,"help-text":_vm.helpText,"label-width":_vm.labelWidth,"input-width":_vm.inputWidth}},[_c('static-widget',{attrs:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }